export default __webpack_public_path__ + "static/media/ic_plain.68239296.png";